import { NotifyHelper } from "../../../helpers/toast";
import { eHinhThucThiActionsObj } from "../../action-types/category/IHinhThucThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const hinhThucThiActions = {
  ...generateActions(eHinhThucThiActionsObj, "HINH_THUC_THI"),
  ...generateActionForKey(
    eHinhThucThiActionsObj,
    "HINH_THUC_THI",
    "LOAD_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
